import React from 'react';
import styled, { css } from 'styled-components';

export const StyledTooltipWrapper = styled.div`
    float: right;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
`;

export const TooltipArrow = styled.div`
    height: 1rem;
    position: absolute;
    width: 1rem;

    &::before {
        border-style: solid;
        content: '';
        display: block;
        height: 0;
        margin: auto;
        width: 0;
    }
    &::after {
        border-style: solid;
        content: '';
        display: block;
        height: 0;
        margin: auto;
        position: absolute;
        width: 0;
    }
    &[data-placement*='bottom'] {
        height: 1rem;
        left: 0;
        margin-top: -0.4rem;
        top: 0;
        width: 1rem;
    }
    &[data-placement*='bottom']::before {
        border-color: transparent transparent rgb(51, 51, 51) transparent;
        border-width: 0 0.5rem 0.4rem 0.5rem;
        position: absolute;
        top: -1px;
    }
    &[data-placement*='bottom']::after {
        border-color: transparent transparent rgb(51, 51, 51) transparent;
        border-width: 0 0.5rem 0.4rem 0.5rem;
    }
    &[data-placement*='top'] {
        bottom: 0;
        height: 1rem;
        left: 0;
        margin-bottom: -1rem;
        width: 1rem;
    }
    &[data-placement*='top']::before {
        border-color: rgb(51, 51, 51) transparent transparent transparent;
        border-width: 0.4rem 0.5rem 0 0.5rem;
        position: absolute;
        top: 1px;
    }
    &[data-placement*='top']::after {
        border-color: rgb(51, 51, 51) transparent transparent transparent;
        border-width: 0.4rem 0.5rem 0 0.5rem;
    }
    &[data-placement*='right'] {
        height: 1rem;
        left: 0;
        margin-left: -0.7rem;
        width: 1rem;
    }
    &[data-placement*='right']::before {
        border-color: transparent rgb(51, 51, 51) transparent transparent;
        border-width: 0.5rem 0.4rem 0.5rem 0;
    }
    &[data-placement*='right']::after {
        border-color: transparent rgb(51, 51, 51) transparent transparent;
        border-width: 0.5rem 0.4rem 0.5rem 0;
        left: 6px;
        top: 0;
    }
    &[data-placement*='left'] {
        height: 1rem;
        margin-right: -0.7rem;
        right: 0;
        width: 1rem;
    }
    &[data-placement*='left']::before {
        border-color: transparent transparent transparent rgb(51, 51, 51);
        border-width: 0.5rem 0 0.5rem 0.4em;
    }
    &[data-placement*='left']::after {
        border-color: transparent transparent transparent rgb(51, 51, 51);
        border-width: 0.5rem 0 0.5rem 0.4em;
        left: 3px;
        top: 0;
    }
`;
export const TooltipContainer = styled.div`
    // border-radius: 3px;
    border: 1px solid rgb(51, 51, 51);
    display: flex;
    flex-direction: column;
    margin: 0.4rem;
    padding: 10px 15px;
    transition: opacity 0.3s;
    z-index: 2147483647;
    color: #ffffff;

    background-color: rgb(51, 51, 51);
    line-height: normal;
    max-width: 260px;
`;

export const StyledTooltipSpan = styled.span`
font-size: 16px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
text-align: center;
cursor: pointer;
${(props) =>
    props.textColor
        ? css`
              color: ${props.textColor};
          `
        : css``};
//   background-color: ${(props) =>
    props.bgColor ? props.bgColor : '#000000'};
 // color: ${(props) => (props.textColor ? props.textColor : '#ffffff')};
`;
